import { DeliveryModel } from '@audibene/ta.utils-opportunity'

const deliveryModelToDisplayText: Record<DeliveryModel, string> = {
  [DeliveryModel.DIRECT_TO_CONSUMER]: 'Direct to Consumer',
  [DeliveryModel.NETWORK]: 'Network',
  [DeliveryModel.NETWORK_HOME_DELIVERY]: 'Network Home Delivery',
  [DeliveryModel.TA_LIGHT]: 'TA Light',
  [DeliveryModel.TA_ONSITE]: 'TA Onsite',
  [DeliveryModel.TELEAUDIOLOGY]: 'Teleaudiology',
}

const deliveryModelsToArray: { key: DeliveryModel; value: string }[] = [
  {
    key: DeliveryModel.DIRECT_TO_CONSUMER,
    value: deliveryModelToDisplayText[DeliveryModel.DIRECT_TO_CONSUMER],
  },
  {
    key: DeliveryModel.NETWORK,
    value: deliveryModelToDisplayText[DeliveryModel.NETWORK],
  },
  {
    key: DeliveryModel.NETWORK_HOME_DELIVERY,
    value: deliveryModelToDisplayText[DeliveryModel.NETWORK_HOME_DELIVERY],
  },
  {
    key: DeliveryModel.TA_LIGHT,
    value: deliveryModelToDisplayText[DeliveryModel.TA_LIGHT],
  },
  {
    key: DeliveryModel.TA_ONSITE,
    value: deliveryModelToDisplayText[DeliveryModel.TA_ONSITE],
  },
  {
    key: DeliveryModel.TELEAUDIOLOGY,
    value: deliveryModelToDisplayText[DeliveryModel.TELEAUDIOLOGY],
  },
]

const allowedDeliveryModelsToArray = (allowedDeliveryModel: DeliveryModel[]) =>
  deliveryModelsToArray.filter(({ key }) => allowedDeliveryModel.includes(key))

export { deliveryModelToDisplayText, deliveryModelsToArray, allowedDeliveryModelsToArray }
